import React, { useEffect, useState } from 'react'
import { LoaderWrapper, ReportHeading, ReportOuterWrapper, MuiButton } from '../../../../components'
import ReportsService from '../../../../services/reports.service'
import { useUpdateLhs, useReactQuery } from '../../../../hooks'
import { useExportToPptObjects } from '../../../../hooks/useExportToPptObjects'
import {
  getObjectAsArray,
  sortByKey,
  getDistinctValues,
  removeHtmlTags,
  formatIfIsPrice,
  convertToNumber,
} from '../../../../util'
import { convertHtmlToPptJson, dynamicSplitData } from '../../../reportsPpt/commonFunctions'
import { useGlobalStore } from '../../../../store'
import { ROLES_MM_PRIMARY } from '../../../../constants'
import AddEditTable from './edit/addEditTable'
import ConfigureTable from './configure/configureTable'
import GridTable from './grid'
// import dataTable from './data'
import decode from 'unescape'
import { RootWrap } from './style'

const ReportCustomTable = (props) => {
  const [tableData, setTableData] = useState([])
  const [rowTableData, setRowTableData] = useState([])
  const [filteredTableData, setFilteredTableData] = useState([])
  const [searchInput, setSearchInput] = useState('')
  const [rowCheckboxObject, setRowCheckboxObject] = useState({
    // row1: {show: true, title: 'row 01'}
  })
  const [columnCheckboxObject, setColumnCheckboxObject] = useState({
    // topic: {show: false, title: ''},
    // column1: {show: false, title: ''},
  })
  const [settings, setSettings] = useState()
  const [sortGridBy, setSortGridBy] = useState({ key: 'topic', direction: true })
  const { user, projectIdValue, isPPTModalActive, exportToPptObject, setExportToPptObject } =
    useGlobalStore()
  const [reportExcelData, setReportExcelData] = useState()

  const [showConfigureTable, setShowConfigureTable] = useState(false)
  const [editItemData, setEditItemData] = useState()
  const [type, setType] = useState()
  const [expandedStatus, setExpandedStatus] = useState(false)
  const [responseObject1, setResponseObject1] = useState()
  // const [responseObject2, setResponseObject2] = useState()
  const [showAdminButtons, setShowAdminButtons] = useState(false)
  const [eventCount, setEventCount] = useState(1)

  const { updateSubLhsApiLoaded } = useUpdateLhs()
  const { updatingExportToPptObject } = useExportToPptObjects()

  // reportSetCustomTableRowApi
  // reportSetCustomTableConfigurationApi

  const useReactQueryObject1 = {
    payloadDetails: {
      queryId: [props.InsightsElementType, props.InsightsElementId, 'tableConfiguration'],
      urlFunc: ReportsService.reportGetCustomTableConfigurationApi,
      payload: { insightsElementId: props.InsightsElementId },
    },
  }
  const useReactQueryObject2 = {
    payloadDetails: {
      queryId: [props.InsightsElementType, props.InsightsElementId, 'tableElement'],
      urlFunc: ReportsService.reportGetCustomTableElementApi,
      payload: { insightsElementId: props.InsightsElementId },
    },
  }
  const {
    data: data1,
    isLoading: isLoading1,
    isSuccess: isSuccess1,
    isError: isError1,
    error: error1,
    refetch: refetch1,
  } = useReactQuery(useReactQueryObject1)
  const {
    data: data2,
    isLoading: isLoading2,
    isSuccess: isSuccess2,
    isError: isError2,
    error: error2,
    refetch: refetch2,
  } = useReactQuery(useReactQueryObject2)

  // const onLoad = (respData) => {
  //   // SORTING ARRAY IN ASCENDING ORDER 'TOPIC'
  //   const tData = sortByKey(respData, 'topic').map(d => d.topic)
  //   const uniqueListObject = tData.reduce((a, v) => ({ ...a, [v.replaceAll(' ','')]: {show:true, title: v}}), {})

  //   setRowCheckboxObject(uniqueListObject)
  //   setTableData(respData)
  // }

  const addingRowSpanFunc = (tData, rowSettings, param) => {
    const isSortBy =
      (param?.type === 'sortBy' && param.key !== 'topic') ||
      (sortGridBy?.key && sortGridBy.key !== 'topic')
    if (isSortBy || (isSortBy && searchInput?.length > 0)) {
      return tData
    }

    // ADDING ROW SPAN (MERGING) and HIDING ROWS
    const topic_rowCountObj = {}
    const tDataFiltered = tData.filter((f) => f.search_showRow)
    const sampleArray = tDataFiltered.map((d) => d.topic)
    sampleArray.forEach(function (x) {
      topic_rowCountObj[x] = (topic_rowCountObj[x] || 0) + 1
    })

    for (let i = 0; i < tDataFiltered.length; i++) {
      tDataFiltered[i].topic_rowSpan = topic_rowCountObj[tDataFiltered[i].topic]
      tDataFiltered[i].topic_showRow = rowSettings[tDataFiltered[i].topic.replaceAll(' ', '')].show
      if (tDataFiltered[i].topic_rowSpan > 0) topic_rowCountObj[tDataFiltered[i].topic] = 0
    }
    return tDataFiltered.filter((f) => f.topic_showRow)
  }

  const addingColSpanFunc = (tData) => {
    // ADDING COL SPAN and HIDING ROWS
    const topic_colCountObj = {}
    const defaultColumnLength = Object.keys(tData[0]).filter((t) => t.indexOf('column') != -1)
    for (let i = 0; i < tData.length; i++) {
      for (let j = 0; j < defaultColumnLength.length - 1; j++) {}
    }

    return tData
  }

  const getSearchedDataFunc = (tData, param) => {
    let value = (param?.type === 'search' && param?.value ? param.value : searchInput).toLowerCase()
    if (param?.type === 'search' && param?.value === '') {
      value = ' '
    }
    if (value?.length > 0) {
      tData = tData.map((tr) => {
        let showRow = tr.topic.toLowerCase().includes(value)
        for (let c = 1; c <= responseObject1.defaultColumnLength; c++) {
          if (!showRow && tr['column' + c].toLowerCase().includes(value)) {
            showRow = true
          }
        }

        return { ...tr, search_showRow: showRow }
      })
    }
    return tData
  }

  const sortDataByKey = (tData, obj) => {
    // SORTING ARRAY IN ASCENDING ORDER 'TOPIC'
    // return tData.sort((a, b) => {
    //   if(a[obj.key] < b[obj.key]) return obj.direction === 'asc'? -1 : 1
    //   if(a[obj.key] > b[obj.key]) return obj.direction === 'asc'? 1 : -1
    //   return 0
    // })
    const key = obj.key === 'topic' ? 'topic' : obj.key + '_value'
    return sortByKey(tData, key, obj.direction)
  }

  const settingsFunc = (param) => {
    // ADDING SETTINGS
    const rowsLength = settings?.rows ? Object.keys(settings.rows).length : 0

    const tableSettings = {
      rows: rowsLength > 0 ? settings?.rows : rowCheckboxObject,
      columns: columnCheckboxObject,
      // rowLength:filteredTableData?.length || 0,
      defaultColumnLength: Object.keys(columnCheckboxObject).length - 1,
      columnLength: Object.keys(columnCheckboxObject).length - 1,
      tabRowTitle: columnCheckboxObject?.topic?.title || '',
      tableRowCustomColumnPercentSize: columnCheckboxObject?.topic?.CustomColumnPercentSize || 0,
    }
    if (param?.type === 'column') {
      tableSettings.columns = param.value
      tableSettings.tabColumnTitle = param?.columnName || settings?.tabColumnTitle || 'Column'
    }
    if (param?.type === 'row') {
      tableSettings.rows = param.value
    }
    setSettings((prev) => ({ ...prev, ...tableSettings }))

    if(tableSettings?.rows?.[""]){
      console.log('tableSettings?.rows?.[""]', tableSettings?.rows?.[""])
      delete tableSettings.rows[""]
    }

    return tableSettings
  }

  const updatedStatesFunc = (param) => {
    if (tableData?.length > 0) {
      let tData = tableData.map((d) => ({
        ...d,
        topic_rowSpan: null,
        topic_showRow: true,
        search_showRow: true,
      }))
      const tableSettings = settingsFunc(param)
      tData = getSearchedDataFunc(tData, param)
      tData = sortDataByKey(tData, param?.type === 'sortBy' ? param : sortGridBy)
      let defaultRowLength = 0
      if (Object.entries(tableSettings?.rows || {})?.[0]?.[0]?.length > 0) {
        defaultRowLength = tData.length
        tData = tData.filter((d) => tableSettings.rows[d.topic.replaceAll(' ', '')]?.show)
      }
      tData = addingRowSpanFunc(tData, tableSettings.rows, param)
      const columnLength = Object.keys(tableSettings.columns)
        .map((d) => tableSettings.columns[d].show)
        .filter((f) => f).length

      setSettings((prev) => ({
        ...prev,
        rowLength: tData?.length,
        defaultRowLength: defaultRowLength,
        columnLength: columnLength,
      }))

      if(isPPTModalActive){
        tData = dynamicSplitData(tData);
      }
      setFilteredTableData(tData)
    }
  }

  const onSearchChange = (val) => {
    setSearchInput(val)
    updatedStatesFunc({ type: 'search', value: val })
  }
  const onCheckboxChange = (type, val) => {
    if (type === 'column') {
      setColumnCheckboxObject(val)
    } else if (type === 'row') {
      setRowCheckboxObject(val)
    }
    updatedStatesFunc({ type: type, value: val })
  }
  const onSortByChange = (val, onLoadDirection = null) => {
    if (onLoadDirection !== null) {
      setSortGridBy({ key: val, direction: onLoadDirection })
      updatedStatesFunc({ type: 'sortBy', key: val, direction: onLoadDirection })
    } else {
      const direction = sortGridBy.key === val ? !sortGridBy.direction : true
      setSortGridBy({ key: val, direction: direction })
      updatedStatesFunc({ type: 'sortBy', key: val, direction: direction })
    }
  }

  const editClickedFunc = (rowData) => {
    setEditItemData(rowData)
    setType('edit')
  }

  const addRowFunc = () => {
    setType('add')
  }

  useEffect(() => {
    updatedStatesFunc()
  }, [tableData])

  const AddRowButton = () => {
    return (
      <>
        {showAdminButtons && (
          <MuiButton
            // variant='contained'
            color='light'
            variant='outlined'
            onClick={() => addRowFunc()}
            label='Add Row'
          />
        )}
        {showAdminButtons && (
          <MuiButton
            // variant='contained'
            variant='outlined'
            color='light'
            onClick={() => setShowConfigureTable(true)}
            label='Configure Table'
          />
        )}
      </>
    )
  }

  const resetAndUpdatingData = () => {
    const uniqueRowIds = getDistinctValues(rowTableData.map((rId) => rId.CustomRowId))
    const uniqueColumnIds = getDistinctValues(
      sortByKey(rowTableData, 'order').map((cId) => cId.CustomColumnId)
    )

    const gridObject = {}
    const finalGridArray = []
    for (let i = 0; i < uniqueRowIds.length; i++) {
      gridObject['row_' + uniqueRowIds[i]] = {} // uniqueColumnIds.map(d => ({['col_'+d]: ''}))
    }
    for (let j = 0; j < rowTableData.length; j++) {
      const obj = rowTableData[j]
      gridObject['row_' + obj.CustomRowId]['col_' + obj.CustomColumnId] = obj.CustomColumnValue
    }

    for (let m = 0; m < uniqueRowIds.length; m++) {
      const rowId = uniqueRowIds[m]
      const object = {
        rowId: rowId,
        id: m,
        topic: gridObject['row_' + rowId]['col_' + uniqueColumnIds[0]],
      }
      for (let c = 1; c <= responseObject1.defaultColumnLength; c++) {
        const value = gridObject['row_' + rowId]['col_' + uniqueColumnIds[c]]
        const strNumber = removeHtmlTags(value, 'removePercent')
        object[`column${c}`] = value
        // object[`column${c}_value`] = strNumber > 0 ? convertToNumber(value) : removeHtmlTags(value)
        object[`column${c}_value`] =
          strNumber > 0
            ? removeHtmlTags(value, 'convertToNumber')
            : removeHtmlTags(value, 'removeNewLine')
        object[`column${c}_type`] = strNumber > 0 ? 'number' : 'string'
      }
      finalGridArray.push(object)
    }

    // SORTING ARRAY IN ASCENDING ORDER 'TOPIC'
    const tData = sortByKey(finalGridArray, 'topic').map((d) => d.topic)
    const uniqueListObject = tData.reduce(
      (a, v) => ({ ...a, [v.replaceAll(' ', '')]: { show: true, title: v } }),
      {}
    )

    setRowCheckboxObject(uniqueListObject)
    setTableData(finalGridArray)
  }

  const reportExcelDataFunc = () => {
    if (
      settings?.defaultColumnLength &&
      rowTableData?.length > 0 &&
      filteredTableData?.length > 0
    ) {
      const reportExcelDataObj = { heading: [], values: [] }
      for (let i = 0; i <= settings.defaultColumnLength; i++) {
        if (i === 0) {
          reportExcelDataObj.heading.push({ title: settings.columns.topic.title })
        } else {
          reportExcelDataObj.heading.push({ title: settings.columns['column' + i].title })
        }
      }
      for (let i = 0; i < settings.rowLength; i++) {
        const array = []
        for (let j = 0; j <= settings.defaultColumnLength; j++) {
          if (j === 0) {
            array.push({ value: removeHtmlTags(filteredTableData[i].topic) })
          } else {
            array.push({
              value: removeHtmlTags(filteredTableData[i]['column' + j], 'replaceSpacing'),
            })
          }
        }
        reportExcelDataObj.values.push(array)
      }
      setReportExcelData(reportExcelDataObj)
    }
  }

  const generatePptObjectFunc = async () => {
    if (isPPTModalActive && props?.type && document.getElementById(props?.type)) {
      const key = props.InsightsElementType + '__' + props.InsightsElementId.replaceAll('-', '_')
      if (!exportToPptObject?.[key]) {
        document.getElementById(props.type).style.width = '1200px'
        const id = document.getElementById(props.type).querySelectorAll('.tableWrapper table')
        const id_row = id[0].querySelectorAll('tr')
        // id[0].setAttribute('width', '1200px')
        for (let i = 0; i < id_row.length; i++) {
          id_row[i].setAttribute('height', id_row[i].offsetHeight)
          id_row[i].style.height = id_row[i].offsetHeight + 'px'
        }
        const finalResultArr = []
        const pptFunc = (index) => {
          if (!!id && index < id.length) {
            const json = convertHtmlToPptJson(id[index], { componentType: 'CustomTable' })
            json.then(function (resultArray) {
              finalResultArr.push(resultArray)
              pptFunc(index + 1)
            })
          } else {
            // const finalResultArray = [finalResultArr[0].slice(0, finalResultArr[0].length/2)] // This line was throwing errors
            const finalResultArray = [finalResultArr[0]]

            function groupValues(arr, maxSum) {
              let groups = []
              let currentGroup = []
              let currentSum = 0

              for (let num of arr) {
                if (currentSum + num <= maxSum) {
                  currentGroup.push(num)
                  currentSum += num
                } else {
                  groups.push(currentGroup) // Save the current group
                  currentGroup = [num] // Start a new group
                  currentSum = num // Reset the sum
                }
              }

              if (currentGroup.length > 0) {
                groups.push(currentGroup) // Add the last group if not empty
              }

              return groups
            }

            const tableHeader = finalResultArray[0][0][0]
            const pptSlideHeightArray = finalResultArray[0].map((h) => Number(h[0].trHeight))
            const maxHtValue = 550 - Number(tableHeader.trHeight)
            const pptSlideHeightGroupedArray = groupValues(pptSlideHeightArray, maxHtValue)

            const pptSlideArray = new Array(pptSlideHeightGroupedArray.length)
            let counter = 0
            for (let i = 0; i < pptSlideHeightGroupedArray.length; i++) {
              pptSlideArray[i] = new Array(pptSlideHeightGroupedArray[i].length)
              for (let j = 0; j < pptSlideHeightGroupedArray[i].length; j++) {
                const obj = finalResultArray[0][counter]
                pptSlideArray[i][j] = obj
                counter = counter + 1
              }
              if (i > 0) {
                pptSlideArray[i].unshift(finalResultArray[0][0])
              }
            }

            const obj = { [key]: pptSlideArray }
            updatingExportToPptObject(obj)
            setTimeout(updateSubLhsApiLoaded(props), 2000)
          }
        }
        pptFunc(0)
      }
    }
  }

  useEffect(() => {
    reportExcelDataFunc()
    setEventCount((p) => p + 1)
  }, [filteredTableData])

  useEffect(() => {
    resetAndUpdatingData(rowTableData)
  }, [rowTableData])

  const addEditTableFunc = (param) => {
    if (param === 'success') {
      setSettings(null)

      setRowTableData([])
      setFilteredTableData([])
      setResponseObject1(null)

      setRowCheckboxObject({})
      setTableData([])

      refetch2()
      setTimeout(refetch1, 1000)
    }
    setEditItemData(null)
    setType(null)
  }
  const updatedConfigureTableFunc = (param) => {
    if (param === 'success') {
      setSettings(null)
      setTimeout(refetch1, 1000)
      setTimeout(refetch2, 2000)
    }
    setShowConfigureTable(false)
  }

  const onDeleteClicked = () => {
    setTimeout(refetch2, 1000)
  }

  const onSuccessFunc1 = (resp) => {
    if (resp?.[0]?.CustomColumnConfigurations?.CustomColumnConfiguration?.length > 0) {
      const key = resp[0].CustomColumnConfigurations.CustomColumnConfiguration.find(
        (f) => f.CustomColumnOrder === 1
      ).CustomColumnName
      const respData = sortByKey(
        resp[0].CustomColumnConfigurations.CustomColumnConfiguration,
        'CustomColumnOrder'
      )
      let rObject = respData.map((d) => ({
        show: true,
        title: d.CustomColumnName,
        id: d.CustomColumnId,
        customColumnOrder: d.CustomColumnOrder,
        customColumnFilterBy: d.CustomColumnFilterBy,
        customColumnSortBy: d.CustomColumnSortBy,
        customColumnDefaultSortBy: d.CustomColumnDefaultSortBy,
        CustomColumnPercentSize: d.CustomColumnPercentSize,
        customColumnDefaultSortOrder: d.CustomColumnDefaultSortOrder.replace(
          'ASCAS',
          'ASC'
        ).replace('DESCD', 'DESC'),
      }))
      //
      // const finalRowObject = {
      //   topic: {show: true, title: rObject[0].title},
      // }
      // for(let c=1; c<=(respData.length-1); c++){
      //   finalRowObject['column'+c] = {show: true, title: rObject[c].title}
      // }

      const allEmpty = rObject.every((d) => d.CustomColumnPercentSize === 0);

      if (allEmpty) {
        const equal = (100 / rObject.length).toFixed();
        rObject = rObject.map((d) => ({
          ...d,
          CustomColumnPercentSize: equal,
        }));
      }

      const finalRowObject = {
        topic: {
          show: true,
          title: rObject[0].title,
          customColumnDefaultSortBy: rObject[0].customColumnDefaultSortBy,
          customColumnDefaultSortOrder: rObject[0].customColumnDefaultSortOrder,
          CustomColumnPercentSize: rObject[0].CustomColumnPercentSize,
        },
        ...Object.fromEntries(
          respData.slice(1).map((_, c) => [
            `column${c + 1}`,
            {
              show: true,
              title: rObject[c + 1].title,
              customColumnOrder: rObject[c + 1].customColumnOrder,
              customColumnFilterBy: rObject[c + 1].customColumnFilterBy,
              customColumnSortBy: rObject[c + 1].customColumnSortBy,
              customColumnDefaultSortBy: rObject[c + 1].customColumnDefaultSortBy,
              customColumnDefaultSortOrder: rObject[c + 1].customColumnDefaultSortOrder,
              CustomColumnPercentSize: rObject[c + 1].CustomColumnPercentSize,
            },
          ])
        ),
      }

      setColumnCheckboxObject(finalRowObject)
      settingsFunc({
        type: 'column',
        value: finalRowObject,
        defaultColumnLength: respData.length - 1,
        columnName: resp[0]?.CustomColumnCategoryName || '',
      })

      setResponseObject1({ data: respData, key: key, defaultColumnLength: respData.length - 1 })
      setEventCount((p) => p + 1)
    }
  }

  const onSuccessFunc2 = (resp) => {
    if (resp?.[0]?.CustomRowColumns?.CustomRowColumn) {
      const data1_Object = data1[0].CustomColumnConfigurations.CustomColumnConfiguration.reduce(
        (acc, item) => {
          acc[item.CustomColumnId] = item.CustomColumnOrder
          return acc
        },
        {}
      )
      const dataArray = sortByKey(resp[0].CustomRowColumns.CustomRowColumn, 'CustomRowId')
        .map((d) => ({ ...d, order: data1_Object[d.CustomColumnId] }))
        .map((d) => {
          return { ...d, CustomColumnValue: formatIfIsPrice(decode(d.CustomColumnValue)) }
        })
      setRowTableData(dataArray)
    } else {
      // NO DATA AVAILABLE HERE
      setRowTableData([])
      setFilteredTableData([])
      setSettings((prev) => ({ ...prev, rowLength: 0 }))
    }
    setEventCount((p) => p + 1)
  }

  useEffect(() => {
    if (isSuccess1 && data1?.length) onSuccessFunc1(data1)
    if (isSuccess2 && data2?.length && isSuccess1 && data1?.length) onSuccessFunc2(data2)

    if (isSuccess1 && isSuccess2) {
      setShowAdminButtons(
        ROLES_MM_PRIMARY.includes(user?.UserType) &&
          isSuccess1 &&
          isSuccess2 &&
          !projectIdValue?.IsFreezed
      )
    }
  }, [isSuccess2, data2, isSuccess1, data1])

  useEffect(() => {
    if (
      isSuccess1 &&
      isSuccess2 &&
      isPPTModalActive &&
      settings?.rowLength > 0 &&
      filteredTableData.length > 0
    ) {
      setTimeout(() => {
        generatePptObjectFunc()
      }, 2000)
    }
  }, [isSuccess2, isSuccess1, isPPTModalActive, settings])

  return (
    <>
      <ReportHeading
        resetInsightHeight={eventCount}
        downloadId={props.type}
        {...props}
        downloadIdData={reportExcelData}
        additionalMiddleButton={<AddRowButton />}
        addTable={true}
      />
      {/* <ReportHeading downloadId={props.type} downloadIdData={htmlToJsonData} subHeading='' {...props} additionalMiddleButton={<BusinessEditButton />} addTable={false} /> */}
      <ReportOuterWrapper>
        {settings?.columnLength && (
          <RootWrap
            id={props.type}
            className={`${props.InsightsElementType} sticky${props.InsightsElementType}`}
            table_cols={settings?.columnLength || 1}
            showAdminButtons={showAdminButtons}
          >
            <LoaderWrapper
              loadOnlyApi={props.loadOnlyApi}
              isLoading={isLoading1 || isLoading2}
              isSuccess={isSuccess1 && isSuccess2}
              isError={isError1 || isError2}
              error={error1 || error2}
            >
              {/* {responseObject1 && settings?.rowLength > 0 && <GridTable insightsElementId={props.InsightsElementId} showAdminButtons={showAdminButtons} rowTableData={rowTableData} data={filteredTableData} settings={settings} editClicked={(d) => editClickedFunc(d)} onSearchChange={(val) => onSearchChange(val)} onCheckBoxChange={(type, val) => onCheckboxChange(type, val)} onSortByChange={s => onSortByChange(s)} sortGridBy={sortGridBy} onDeleteClicked={() => onDeleteClicked()} />}
            {responseObject1 && settings?.rowLength === 0 && <>No Data Found</>} */}
              {responseObject1 && settings?.defaultRowLength > 0 && (
                <GridTable
                  insightsElementId={props.InsightsElementId}
                  showAdminButtons={showAdminButtons}
                  rowTableData={rowTableData}
                  data={filteredTableData}
                  settings={settings}
                  editClicked={(d) => editClickedFunc(d)}
                  onSearchChange={(val) => onSearchChange(val)}
                  onCheckBoxChange={(type, val) => onCheckboxChange(type, val)}
                  onSortByChange={(s, o) => onSortByChange(s, o)}
                  sortGridBy={sortGridBy}
                  onDeleteClicked={() => onDeleteClicked()}
                />
              )}
              {responseObject1 && settings?.defaultRowLength === 0 && <>No Data Found</>}
              {/* {responseObject1 && <GridTable insightsElementId={props.InsightsElementId} showAdminButtons={showAdminButtons} rowTableData={rowTableData} data={filteredTableData} settings={settings} editClicked={(d) => editClickedFunc(d)} onSearchChange={(val) => onSearchChange(val)} onCheckBoxChange={(type, val) => onCheckboxChange(type, val)} onSortByChange={s => onSortByChange(s)} sortGridBy={sortGridBy} onDeleteClicked={() => onDeleteClicked()} />}
            {responseObject1 && settings?.rowLength === 0 && <>No Data Found</>} */}
              {showAdminButtons && (
                <>
                  {(editItemData || type == 'add') && (
                    <AddEditTable
                      InsightsElementId={props.InsightsElementId}
                      settings={responseObject1}
                      type={type}
                      data={editItemData}
                      onClose={() => addEditTableFunc('close')}
                      onSuccess={() => addEditTableFunc('success')}
                    />
                  )}
                  {isSuccess1 && showConfigureTable && (
                    <ConfigureTable
                      InsightsElementId={props.InsightsElementId}
                      settings={responseObject1}
                      data={data1}
                      onClose={() => updatedConfigureTableFunc('close')}
                      onSuccess={() => updatedConfigureTableFunc('success')}
                    />
                  )}
                </>
              )}
            </LoaderWrapper>
          </RootWrap>
        )}
      </ReportOuterWrapper>
    </>
  )
}

export default ReportCustomTable
